import React from 'react'
import { Link } from 'react-router-dom'
import AppHeader from '../AppHeader'

function DashboardComponent() {
  return (
    <>
        <AppHeader/>
        <div className='container'>
            <div className='row mt-5 text-center'>
                <div className='col-md-4 my-3'>
                    <div className='card border border-success p-3 ' >
                        <Link to={"/checkin/queue"} className='btn text-success btn-lg'>
                            <h3></h3>
                            <p>Book token for today</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-4 my-3'>
                    <div className='card bg-success p-3 ' >
                        <Link to={"/schedule-checkin/queue"} className='btn text-white btn-lg'>
                            <h3></h3>
                            <p>Book token for upcoming days </p>
                        </Link>
                    </div>
                </div>
                <div className='col-md-4 my-3'>
                    <div className='card bg-primary p-3 ' >
                        <Link to={"/token-details"} className='btn text-white btn-lg'>
                            <h3></h3>
                            <p>My Token List </p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default DashboardComponent